<template>
  <zm-tabs ref="tab" v-model="activeName" @tab-click="handleTabClick" class="countries-tabs" aria-label="Enable Calling for Countries/Regions" v-loading="loading && !isIE">
    <template v-if="ready">
      <zm-tab-pane
       v-if="getCurrentBasePlanInfo.planType !== 'video_sdk'"
       :label="`${$t('billing.toll_free')} (${tollFreeCountrySelections.length})`" :name="AUDIO_RATE_TYPES.TOLL_FREE">
        <rate-regions-table
          :active="activeName === AUDIO_RATE_TYPES.TOLL_FREE"
          :country-list="tollFreeCountryList"
          :selected-countries="tollFreeCountrySelections"
          @update-countries="updateCountries(AUDIO_RATE_TYPES.TOLL_FREE, $event)"
          @select="handleSelect(AUDIO_RATE_TYPES.TOLL_FREE, $event)"
          @select-all="handleSelectAll(AUDIO_RATE_TYPES.TOLL_FREE, $event)"
        ></rate-regions-table>
      </zm-tab-pane>
      <zm-tab-pane
        v-if="getCurrentBasePlanInfo.planType !== 'video_sdk'"
        :label="`${$t('billing.premium_call_in_numbers')} (${premiumCountrySelections.length})`"
        :name="AUDIO_RATE_TYPES.PREMIUM"
      >
        <rate-regions-table
          :active="activeName === AUDIO_RATE_TYPES.PREMIUM"
          :country-list="premiumCountryList"
          :selected-countries="premiumCountrySelections"
          @update-countries="updateCountries(AUDIO_RATE_TYPES.PREMIUM, $event)"
          @select="handleSelect(AUDIO_RATE_TYPES.PREMIUM, $event)"
          @select-all="handleSelectAll(AUDIO_RATE_TYPES.PREMIUM, $event)"
        ></rate-regions-table>
      </zm-tab-pane>
      <zm-tab-pane :label="`${$t('billing.call_out')} (${callOutCountrySelections.length})`" :name="AUDIO_RATE_TYPES.CALL_OUT">
        <rate-regions-table
          :active="activeName === AUDIO_RATE_TYPES.CALL_OUT"
          :country-list="callOutCountryList"
          :selected-countries="callOutCountrySelections"
          @update-countries="updateCountries(AUDIO_RATE_TYPES.CALL_OUT, $event)"
          @select="handleSelect(AUDIO_RATE_TYPES.CALL_OUT, $event)"
          @select-all="handleSelectAll(AUDIO_RATE_TYPES.CALL_OUT, $event)"
        ></rate-regions-table>
      </zm-tab-pane>
    </template>
  </zm-tabs>
</template>
<script>
import { get } from 'lodash';
import { AUDIO_RATE_TYPES, AUDIO_BUNDLE_TYPE, planTypes } from '@/common/constants';
import RateRegionsTable from "./rate-regions-table.vue";
import { getAudioCountries } from '@/apis';
import { mapGetters } from 'vuex';

const trackingMap = {
  [AUDIO_RATE_TYPES.PREMIUM]: 'toll call',
  [AUDIO_RATE_TYPES.CALL_OUT]: 'call out',
  [AUDIO_RATE_TYPES.TOLL_FREE]: 'toll-free',
};
export default {
  data() {
    return {
      rateData: null,
      activeName: AUDIO_RATE_TYPES.TOLL_FREE,
      tollFreeCountryList: [],
      tollFreeCountrySelections: [],
      callOutCountryList: [],
      callOutCountrySelections: [],
      premiumCountryList: [],
      premiumCountrySelections: [],
      AUDIO_RATE_TYPES,
      ready: false,
      loading: true,
    };
  },
  props: {
    rateType: {
      type: String,
      default: '',
    },
    bundleType: {
      type: String,
      default: '',
    },
    selections: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.loadRateData();
    if(this.getCurrentBasePlanInfo.planType === planTypes.VIDEO_SDK) {
      this.activeName = AUDIO_RATE_TYPES.CALL_OUT;
    }
  },
  methods: {
    handleSelectAll(name, values) {
      const listMap = {
        [AUDIO_RATE_TYPES.PREMIUM]: this.premiumCountryList,
        [AUDIO_RATE_TYPES.CALL_OUT]: this.callOutCountryList,
        [AUDIO_RATE_TYPES.TOLL_FREE]: this.tollFreeCountryList,
      }
      // because when user selected us & ca unlimited plan. The us & ca is disabled.
      const isSelectedAll = (values.length >= (listMap[name] || []).length - 2) && values.length > 0;

      const basePlanNameKey = get(this.getCurrentBasePlanInfo, 'plans[0].planNameKey', '');
      this.$tracking.buyInteraction(
        `${this.$t(basePlanNameKey)} add-ons`,
        `Audio Conferencing - ${trackingMap[name]} - ${isSelectedAll ? 'select all' : 'deselect all'}`);
    },
    handleSelect(name, value) {
      const { regionName, isSelected } = value;
      const basePlanNameKey = get(this.getCurrentBasePlanInfo, 'plans[0].planNameKey', '');
      this.$tracking.buyInteraction(
        `${this.$t(basePlanNameKey)} add-ons`,
        `Audio Conferencing - ${trackingMap[name]} - ${isSelected ? 'select' : 'deselect'} - ${regionName}`);
    },
    loadRateData() {
      getAudioCountries(this.$context.currency).then(res => {
        this.rateData = get(res, 'result.defaultAudioRate', {});
        this.getTableList(this.rateData, this.rateType);
        this.initSelections();
        this.ready = true;
      });
    },
    initSelections() {
      this.callOutCountrySelections = get(this.selections, AUDIO_RATE_TYPES.CALL_OUT, []);
      this.tollFreeCountrySelections = get(this.selections, AUDIO_RATE_TYPES.TOLL_FREE, []);
      this.premiumCountrySelections = get(this.selections, AUDIO_RATE_TYPES.PREMIUM, []);
    },
    getTableList(rateData, rateType) {
      const rateObj = rateData[rateType];
      if(rateObj && rateObj.tollfreeRates) {
        this.tollFreeCountryList = this.rateMapFn(rateObj.tollfreeRates);
      }
      if(rateObj && rateObj.calloutRates) {
        this.callOutCountryList = this.rateMapFn(rateObj.calloutRates);
      }
      if(rateObj && rateObj.premiumRates) {
        this.premiumCountryList = this.rateMapFn(rateObj.premiumRates);
      }
      this.loading = false;
    },
    rateMapFn(rates) {
      return Object.keys(rates).map(key => ({
        id: key,
        regionName: this.getCountryName(key),
        ...rates[key],
        disabled: this.disabledCounties.indexOf(key) !== -1,
      }));
    },
    updateCountries(type, countryIds) {
      switch (type) {
        case AUDIO_RATE_TYPES.CALL_OUT:
          this.callOutCountrySelections = countryIds;
          break;
        case AUDIO_RATE_TYPES.TOLL_FREE:
          this.tollFreeCountrySelections = countryIds;
          break;
        case AUDIO_RATE_TYPES.PREMIUM:
          this.premiumCountrySelections = countryIds;
          break;
      }
      this.$emit('selection-change', { type, countryIds});
    },
    getCountryName(cid) {
      if (!cid) return '';
      const sctyName=window.sctyName?JSON.parse(window.sctyName):null;
      if (sctyName && sctyName[cid]) {
        return this.$t(sctyName[cid]);
      } else {
        return this.$t(`country.${cid}`);
      }
    },
    handleTabClick(events) {
      const tabName = events?._props?.name
      const basePlanNameKey = get(this.getCurrentBasePlanInfo, 'plans[0].planNameKey', '');
      this.$tracking.buyInteraction(
        `${this.$t(basePlanNameKey)} add-ons`,
        `Audio Conferencing - ${trackingMap[tabName]}`);
    },
  },
  computed: {
    ...mapGetters(['getCurrentBasePlanInfo']),
    isIE() {
      return typeof Proxy === 'undefined';
    },
    disabledCounties() {
      if(this.bundleType === AUDIO_BUNDLE_TYPE.US_CA) {
        return ['US', 'CA']
      }
      return [];
    },
  },
  watch: {
    rateType(val, oldVal) {
      if(val !== oldVal) {
        this.loading = true;
        setTimeout(() => {
          this.getTableList(this.rateData, val);
        })
      }
    },
    bundleType(v, ov) {
      if(v !== ov) {
        this.loading = true;
        setTimeout(() => {
          this.getTableList(this.rateData, this.rateType);
        })
      }
    },
  },
  components: {
    RateRegionsTable,
  },
}
</script>
<style lang="scss">
.countries-tabs {
  border-radius: 12px;
  border: 1px solid #B8B8C4;
  padding: 16px 16px 8px;
  overflow: hidden;
  .zm-tabs__header {
    margin-bottom: 19px;
  }
  .zm-tabs__item {
    text-align: center;
    font-family: 'SF Pro', 'Almaden Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px; 
    padding: 4px 0px;
  }
  .zm-tabs__nav-next, .zm-tabs__nav-prev{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
